import { commonConstants } from '../_constants';
import { initialState } from '../_helpers';

export function flightDays(state=initialState.flightDays, action) {
     switch (action.type) {
        case commonConstants.FLIGHT_DAYS_SUCCESS:
            return Object.assign({}, state, action.flightDays);
        default:
          return state
      }
}


// WEBPACK FOOTER //
// ./src/_reducers/flightDays.reducer.js